import { render, staticRenderFns } from "./BoardMembers.vue?vue&type=template&id=0ae5e9f9"
import script from "./BoardMembers.vue?vue&type=script&lang=js"
export * from "./BoardMembers.vue?vue&type=script&lang=js"
import style0 from "./BoardMembers.vue?vue&type=style&index=0&id=0ae5e9f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports